module.exports = __webpack_public_path__ + "img/arrow-left.ada1386a.svg";